export default __webpack_public_path__ + "static/img_logo_ichi_white-5e91b9c4b31a6c792bd90f89a539491a.svg";